import { DecimalPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, forwardRef, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { SafePipe, STYLE_SERVICE, UButtonModule, UIconModule } from '@local/ui-infra';
import { ArmEmulatorPopupComponent } from '@shared/components/arm-emulator-popup/arm-emulator-popup.component';
import { SessionExpirePopupComponent } from '@shared/components/session-expire-popup/session-expire-popup.component';
import { EmbedService } from '@shared/embed.service';
import {
  globalNativeMainRpcProvider,
  globalNativeServiceRpcProvider,
  globalServicesRpcProvider,
  LogService,
  NativeMainRpcService,
  WindowService,
} from '@shared/services';
import { SessionService } from '@shared/services/session.service';
import { StyleService } from '@shared/services/style.service';
import { AppComponent } from './app.component';
import { GoLinkRedirectComponent } from './bar/views/results-views/go-links/go-links-redirector.component';
import { GlobalErrorHandler } from './global-error-handler';
import { AppRoutingModule } from './routes/app-routing.module';
import { RouteReuseService } from './bar/services/route-reuse.service';
import { RouteReuseStrategy } from '@angular/router';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';

@NgModule({
  declarations: [AppComponent, SessionExpirePopupComponent, ArmEmulatorPopupComponent, GoLinkRedirectComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: false,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    UIconModule,
    UButtonModule,
    SafePipe,
    MonacoEditorModule.forRoot(),
  ],

  providers: [
    globalNativeMainRpcProvider,
    globalNativeServiceRpcProvider,
    {
      provide: WindowService,
      useFactory: (host: NativeMainRpcService) => {
        return host ? new WindowService(host) : null;
      },
      deps: [NativeMainRpcService],
    },
    globalServicesRpcProvider,
    DecimalPipe,
    {
      provide: EmbedService,
      useFactory: () => (<any>window).__embedService,
    },
    SessionService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler, deps: [LogService] },
    { provide: GlobalErrorHandler, useExisting: forwardRef(() => ErrorHandler), deps: [LogService] },
    {
      provide: LogService,
      useFactory: () => {
        return new LogService((<any>window).__module.logger);
      },
      deps: [],
    },
    { provide: STYLE_SERVICE, useClass: StyleService },
    { provide: RouteReuseStrategy, useClass: RouteReuseService },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
